import { Button } from 'foundations-components/transitional/components/Button';
import { LoadingButton } from 'foundations-components/transitional/components/LoadingButton';
import { PlayerPlayIcon } from 'foundations-assets/icons/components/PlayerPlayIcon';
import { IconCircle } from 'foundations-components/transitional/components/IconCircle';
import { Image } from 'foundations-components/transitional/components/Image';
import { Flex } from 'foundations-components/components/Flex';
import UsageTracker from '../../../utils/UsageTracker';
import { H1 } from 'foundations-components/transitional/components/H1';
import FormattedMessage from 'I18n/components/FormattedMessage';
import { useCreatePortalMutation } from '../../../../__generated__/chirp/com/hubspot/academy/simulation/environment/rpc/PortalService.hooks';
//@ts-expect-error Could not find declaration file for module
import thumbnailUrl from 'bender-url!../../../../images/pngs/sequence-screen.png';
import { FloatingAlertStore } from 'foundations-components/transitional/components/FloatingAlertList';
import { View } from 'foundations-components/components/View';
import Raven from 'raven-js';
import { getFullUrl } from 'hubspot-url-utils';
import PortalIdParser from 'PortalIdParser';
import { useHasScope } from '../../accounts/accountsQueries';
import { redirectTo } from '../../../utils/urls';
import { getPracticeModeConfig } from '../practiceModeConsts';
import { stringify } from 'hub-http/helpers/params';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
const Container = ({
  children
}) => {
  return /*#__PURE__*/_jsx(View, {
    position: "relative",
    children: /*#__PURE__*/_jsxs(Flex, {
      flexDirection: "column",
      position: "relative",
      children: [/*#__PURE__*/_jsx(Image, {
        alt: "practice-mode-overlay",
        src: thumbnailUrl
      }), /*#__PURE__*/_jsx(View, {
        backgroundColor: "specialty-scrim",
        inlineSize: "100%",
        insetBlockEnd: "0",
        insetInlineStart: "0",
        position: "absolute",
        children: /*#__PURE__*/_jsx(Flex, {
          alignItems: "center",
          flexDirection: "column",
          justifyContent: "center",
          marginBlock: "400",
          children: children
        })
      })]
    })
  });
};
const PracticeModeOverlay = ({
  otgId,
  hidePracticeMode
}) => {
  const config = getPracticeModeConfig(otgId);
  const {
    hasScope
  } = useHasScope(config === null || config === void 0 ? void 0 : config.scope);
  const [createPortal, {
    loading,
    data
  }] = useCreatePortalMutation({
    onCompleted: () => {
      UsageTracker.track('contentInteraction', {
        action: 'practice-mode-enter-practice-mode-clicked',
        shortId: String(otgId),
        contentId: String(otgId)
      });
      const portalId = PortalIdParser.get();
      const practicePortalId = data === null || data === void 0 ? void 0 : data.portalId;
      const toolPath = config === null || config === void 0 ? void 0 : config.toolPath;
      const upgradePoint = config === null || config === void 0 ? void 0 : config.upgradePoint;
      const params = stringify({
        practicePortalId,
        otg: otgId,
        toolPath,
        originPortalId: portalId,
        hasScope,
        upgradePoint
      });
      const practiceModeUrl = `${getFullUrl('app')}/academy/${practicePortalId}/practice-mode?${params}`;
      redirectTo(practiceModeUrl);
    },
    onError: error => {
      FloatingAlertStore.addAlert({
        type: 'danger',
        message: /*#__PURE__*/_jsx(FormattedMessage, {
          message: "learningCenter.practiceMode.video.createPortalFailedMessage"
        })
      });
      Raven.captureException(error);
    }
  });
  const handleWatchInPracticeMode = () => {
    UsageTracker.track('contentInteraction', {
      action: 'practice-mode-cta-watch-in-practice-mode-clicked',
      shortId: String(otgId),
      contentId: String(otgId)
    });
    createPortal({
      variables: {
        exerciseId: 0 // We don't need an exercise id for practice mode so we set it to 0
      }
    }).catch(Raven.captureException.bind(Raven));
  };
  const handleWatchHere = () => {
    UsageTracker.track('contentInteraction', {
      action: 'practice-mode-cta-watch-here-clicked',
      shortId: String(otgId),
      contentId: String(otgId)
    });
    hidePracticeMode();
  };
  return /*#__PURE__*/_jsxs(Container, {
    children: [/*#__PURE__*/_jsx(Flex, {
      flexDirection: "column",
      gap: "200",
      children: /*#__PURE__*/_jsx(H1, {
        color: "text-core-on-fill-default",
        children: /*#__PURE__*/_jsx(FormattedMessage, {
          message: "learningCenter.practiceMode.video.heading"
        })
      })
    }), /*#__PURE__*/_jsxs(Flex, {
      flexDirection: "row",
      gap: "300",
      children: [/*#__PURE__*/_jsx(LoadingButton, {
        "data-test-id": "watch-in-practice-mode-button",
        loading: loading,
        onClick: handleWatchInPracticeMode,
        size: "medium",
        use: "tertiary-extra-light",
        children: /*#__PURE__*/_jsxs(Flex, {
          alignItems: "center",
          flexDirection: "row",
          gap: "200",
          children: [/*#__PURE__*/_jsx(FormattedMessage, {
            message: "learningCenter.practiceMode.video.practiceModeCta"
          }), /*#__PURE__*/_jsx(IconCircle, {
            backgroundColor: "fill-accent-orange-default",
            borderWidth: "0",
            color: "fill-surface-default",
            icon: PlayerPlayIcon,
            padding: "100",
            size: "100"
          })]
        })
      }), /*#__PURE__*/_jsx(Button, {
        "data-test-id": "watch-here-button",
        onClick: handleWatchHere,
        size: "medium",
        use: "secondary-ghost",
        children: /*#__PURE__*/_jsxs(Flex, {
          alignItems: "center",
          flexDirection: "row",
          gap: "200",
          children: [/*#__PURE__*/_jsx(FormattedMessage, {
            message: "learningCenter.practiceMode.video.watchHereCta"
          }), /*#__PURE__*/_jsx(IconCircle, {
            backgroundColor: "fill-accent-orange-default",
            borderWidth: "0",
            color: "fill-surface-default",
            icon: PlayerPlayIcon,
            padding: "100",
            size: "100"
          })]
        })
      })]
    })]
  });
};
export default PracticeModeOverlay;